import AuthService from "../login/auth.service";
import { comprobantes, dimo, pagoPix } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class PagoDepositoExtraccionQrService {

  async getDecodificarQr(hashQr, imagen64) {

    let data = {
      qrCobro: hashQr,
      imagen64: imagen64
    };

    var config = {
      method: "POST",
      url: dimo + "v3/qr/leerQR",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async pagarQr(data) {

    var config = {
      method: "POST",
      url: dimo + "v3/qr/comprasQR",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async depositarQr(data, comercio) {

    var config = {
      method: "POST",
      url: dimo + "depositoQR?comercio="+comercio,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async extraerQr(data, comercio) {

    var config = {
      method: "POST",
      url: dimo + "extraccionQR?comercio="+comercio,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async extraerAtmQr(data, comercio, codDestinatario) {

    var config = {
      method: "POST",
      url: dimo + "extraccionATMQR?atm="+comercio+'&codDestinatario='+codDestinatario,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async getTarjetasCabal() {

    var config = {
      method: "POST",
      url: dimo + "dimoTarjetas/getTarjetasPanalCabal",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: {
        canal: "WEB"
      }
    };

    return await axios(config);
  }

  async descargarComprobante(data) {

    var _url = comprobantes + "comprobantes/v2/pagos-qr-v3";

    var config = {
      method: "POST",
      url: _url,
      data: data,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }


  async getListaPix() {

    var _url = pagoPix + "/transaccion/comprobante";

    var config = {
      method: "GET",
      url: _url,
      responseType: "json",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }



  async descargaReimpresionPix(titulo,importe, nroSocioTitular, comercio, fechaOperacion) {

    var _url = comprobantes + "comprobantes/v2/pagos-qr-pix-reimpresion";
    var data = JSON.stringify({
      titulo: titulo,
      monto: importe,
      nroSocioTitular: nroSocioTitular,
      
      comercio: comercio,
      fechaOperacion: fechaOperacion,
      
      
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);

  }


}
export default new PagoDepositoExtraccionQrService();
